/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { NEW_PATH_DELIMITER } from '@picsio/db/src/constants';
import { setField, makeTree, DEFAULT_SAVED_SEARCH_TREE_SORT } from '../helpers/savedSearches';

export const rename = createAsyncThunk(
  'savedSearches/rename',
  async (
    { _id, name },
    {
      extra: { sdk, Logger, Toast },
      getState,
    },
  ) => {
    try {
      await sdk.savedSearches.rename(_id, name);

      return { _id, name, userId: getState().user._id };
    } catch (error) {
      Logger.error(new Error('Can not rename saved search'), { error }, [
        'RenameSavedSearchesFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);

      Toast('Error renaming saved search', { type: 'error' });

      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    rename.pending,
    (state, { meta: { arg: { _id } } }) => {
      state.tree = setField(state.tree, _id, 'isBusy', true);
    },
  ).addCase(
    rename.fulfilled,
    (state, { payload: { _id, name, userId } }) => {
      state.all = state.all.map((ss) => {
        if (ss._id !== _id) return ss;
        // The path's last segment also stores the search name; keep them in
        // sync with the server (which rewrites both via `db.savedSearches.rename`).
        let path = ss.path;
        if (path) {
          const idx = path.lastIndexOf(NEW_PATH_DELIMITER);
          path = idx >= 0
            ? `${path.substring(0, idx)}${NEW_PATH_DELIMITER}${name}`
            : `${NEW_PATH_DELIMITER}${name}`;
        }
        return { ...ss, name, path };
      });
      // Re-derive the tree so the renamed leaf appears under its (possibly
      // virtual) group with the new name. Using setField alone left the tree's
      // virtual-group children stale.
      state.tree = makeTree(
        state.all,
        userId,
        state.searchQuery,
        state.treeSortType || DEFAULT_SAVED_SEARCH_TREE_SORT,
      );
    },
  ).addCase(
    rename.rejected,
    (state, { error, meta: { arg: { _id } } }) => {
      state.error = error;
      state.tree = setField(state.tree, _id, 'isBusy', false);
    },
  );
};
